// extracted by mini-css-extract-plugin
export default {"close":"CloseAccount_close__de40Y","warning":"CloseAccount_warning__lBva8","modalDisplay":"CloseAccount_modalDisplay__vf5NJ"};